<template>
  <div>
     <Alert :closable="false" type="warning" class="alert-default" v-if="!hideQuotes()">
          <svgicon name="icon-risk" width="13" height="13" />
          {{$t('INDENT_NO_VIEW_TRANSPORTER_QUOTES_PERMISSION')}}
        </Alert>
    <div v-if="hideQuotes()">
      <div class="buttons-top">
        <div class="bid-expiry">
        {{$t('INDENT_BID_EXPIRY')}}: <strong>{{ $moment(rfqData.expires_at).format('DD MMM YYYY | hh:mm A') }}</strong>
        </div>
        <div class="buttons-grp">
          <div class="popup-empty" v-if="hideQuotes() && [1,3].includes(rfqData.status) && !showAction() && !isApprovalPending">
            <button class="btn btn-secondary" @click="$emit('reindent', rfqData)">{{$t('INDENT_RE_INDENT')}}</button>
          </div>
          <div class="btn-group" v-else-if="isApprovalPending && hideQuotes() && !showButtons() && hidebuttons()">
            <button
              v-if="$hasPermission('rfq_update')"
              class="btn btn-secondary"
              :disabled="!rfqData.user_action"
              @click="statusUpdate(RFQConstants.QuoteStatus.TRANSPORTER_ACCEPT)"
            >{{$t('INDENT_REJECT')}}</button>
            <button
              v-if="$hasPermission('rfq_update')"
              class="btn btn-primary ml-5"
              :disabled="!rfqData.user_action"
              @click="approveQuote"
            >{{$t('INDENT_APPROVE')}}</button>
          </div>

          <div class="btn-group" v-else-if="hideQuotes() && showAction() && !showButtons() && hidebuttons()">

            <span v-if="$hasPermission('rfq_update')">
              <!-- Reject all -->
              <button
                v-if="rfqComment"
                class="btn btn-secondary"
                :disabled="!rfqComment || this.$hasPermission('hide_rfq_quotes_price')"
                @click="rejectAll"
              >{{$t('INDENT_REJECT_ALL')}}</button>
              <Tooltip
                v-else
                popper-class="max-width"
                :open-delay="200"
                effect="dark"
                placement="bottom-start">
                  <div slot="content">{{$t('INDENT_COMMENT_MANDATORY')}}</div>
                  <span class="pointer">
                    <button
                      class="btn btn-secondary"
                      :disabled="!rfqComment || this.$hasPermission('hide_rfq_quotes_price')"
                    >{{$t('INDENT_REJECT_ALL')}}</button>
                  </span>
              </Tooltip>

              <!-- Select -->
              <button
                v-if="!disableSelect"
                class="btn btn-secondary"
                :disabled="disableSelect"
                @click="statusUpdate(RFQConstants.QuoteStatus.SHIPPER_SELECT)"
              >{{$t('SELECT')}}</button>
              <Tooltip
                v-else
                popper-class="max-width"
                :open-delay="200"
                effect="dark"
                placement="bottom-start">
                  <div slot="content">{{$t('INDENT_SELECT_MANDATORY')}}</div>
                  <span class="pointer">
                    <button
                      class="btn btn-secondary"
                      :disabled="disableSelect"
                    >{{$t('SELECT')}}</button>
                  </span>
              </Tooltip>
            </span>

          </div>
        </div>
      </div>
      <div class="popover-top px-0" v-if="showHistoricalPrice()">
        <h3>{{$t('BIDS_HISTORICAL_PRICE')}} : <strong>{{getHistoricalPrice}}</strong></h3>
      </div>
      <div class="popover-top px-0" v-if="showCeilingPrice()">
        <h3>{{$t('BIDS_CEILING_PRICE')}} : <strong>{{getCeilingPrice()}}</strong></h3>
      </div>
      <div class="tablepanel popover-minwidth" v-if="!error">
    <div class="new">
      <div class="table" v-if="rfqData.quotes && rfqData.quotes.length > 0">

        <div class="table-header table-headborder">
          <div class="table-row">
            <div class="table-th w250">{{$t('INDENT_TRANSPORTERS')}}</div>
            <div class="table-th w150" v-if="hideQuotes()">{{$t('INDENT_VEHICLE_TYPE')}}</div>
            <div class="table-th w250" v-if="hideQuotes()">{{$t('INDENT_BASE_QUOTE')}} <span v-if="rfqData.quotes.length">( {{ getFreightUnit(rfqData.quotes[0].freight_unit).name }} )</span></div>
            <div class="table-th w100" v-if="hideQuotes()">{{$t('INDENT_REMARKS')}}</div>
            </div>
          </div>
        </div>
        <radio-group v-model="selected" class="table-bgcolor popscroll">
          <div class="table-row table-rowbg" :class="[hideQuotes() && quote.diff_percent != null ? quote.diff_percent>0 ? 'table-secborder' : 'table-primaryborder' : 'table-transparentborder']"
            v-for="quote in rfqData.quotes" :key="quote.transporter.id">
            <div class="table-td w250">
              <div class="flex-center">
                <radio :label="quote.transporter.id" v-if="history" :disabled="disableQuote(quote.status)">
                  <Tooltip v-if="getTooltipContent(quote.status, rfqData.status)"
                    placement="top-start" :disabled="!disableQuote(quote.status)">
                    <div slot="content">{{getTooltipContent(quote.status, rfqData.status)}}</div>
                    <span class="trimmed d-unset">
                      <Ellipsis :text="quote.transporter.name" :length="18" />
                    </span>
                  </Tooltip>
                  <span v-else class="trimmed d-unset">
                    <Ellipsis :text="quote.transporter.name" :length="18" />
                  </span>
                </radio>
                <div v-else>
                  <span class="trimmed d-unset">
                    <Ellipsis :text="quote.transporter.name" :length="18" />
                  </span>
                </div>
                <div class="text-xxs status status-teal" v-if="(quote.status === RFQConstants.QuoteStatus.SHIPPER_SELECT)">
                  {{ $t('SELECTED') }}
                </div>
                <div class="text-xxs status status-red" v-else-if="quote.user_rejected && !isApprovalPending">
                  {{ $t('REJECTED') }}
                </div>
              </div>
            </div>
            <div class="table-td w100" v-if="hideQuotes()">
              <div v-if="quote.vehicle_type">
                <Ellipsis :text="quote.vehicle_type.short_form" :length="12" />
              </div>
            </div>
            <div class="table-td w75">
              <div v-if="hideQuotes() && quote.vehicle_diff_percent!=null">
                <span v-if="quote.vehicle_diff_percent>0">{{Number(quote.vehicle_diff_percent)}} kg</span>
                <span v-else-if="quote.vehicle_diff_percent<0">{{Number(quote.vehicle_diff_percent * -1 )}} kg</span>

                <svgicon
                  name="primaryarrow"
                  width="10"
                  height="10"
                  v-if="quote.vehicle_diff_percent>0"
                  :original="true"
                  class="psvg svg-rotate"
                />
                <svgicon
                  name="secarrow"
                  width="10"
                  height="10"
                  v-else-if="quote.vehicle_diff_percent<0"
                  :original="true"
                  class="psvg svg-rotate"
                />
              </div>
            </div>

            <div v-bind:class="getClass(quote)" v-if="hideQuotes()">
              <div v-if="quote.freight_charge && showFreightCharges()">{{quote.freight_charge}}</div>
              <div v-else-if="quote.freight_charge" > <svgicon name="Cost" width="13" height="13" />  </div>
            </div>

            <div class="table-td w100" v-if="hideQuotes() && quote.diff_percent!=null">
              <span v-if="quote.diff_percent>0">{{Number(quote.diff_percent).toFixed(2)}}%</span>
              <span v-else>{{Number(quote.diff_percent*-1).toFixed(2)}}%</span>
              <svgicon
                name="secarrow"
                width="10"
                height="10"
                v-if="quote.diff_percent>0"
                :original="true"
                class="psvg"
              />
              <svgicon
                name="primaryarrow"
                width="10"
                height="10"
                v-else
                :original="true"
                class="psvg"
              />
            </div>
            <div class="table-td w-200" v-if="hideQuotes()">
              <span v-if="quote.quote_remarks">
                <Ellipsis :text="quote.quote_remarks" :length="20" />
              </span>
              <span v-else>
              </span>
            </div>
            </div>
          </radio-group>
          <div class="reason-footer">
          <div class="reason-input" v-if="hideQuotes() && showAction() && !showButtons() && hidebuttons()">
            <label class="reason-text">{{$t('INDENT_REASON')}}:</label>
            <input type="text" v-model="rfqComment" :placeholder="$t('INDENT_ENTER_REASON')" />
          </div>
         </div>
        </div>
      </div>
    </div>

    <div class="status-msg my-md" v-if="!rfqData || error">
      <span>
        <svgicon name="empty-timeline" width="180" height="130" :original="true" />
        <p class="ml-30">{{$t('INDENT_NO_DATA_FOUND')}}</p>
      </span>
    </div>
    <div class="status-msg my-md" v-if="rfqData && rfqData.quotes && !rfqData.quotes.length ">
      <span>
        <svgicon name="empty-timeline" width="180" height="130" :original="true" />
        <p class="ml-30">{{$t('INDENT_BID_IN_PROGRESS')}}</p>
      </span>
    </div>
    <Collapse  accordion class="collapse-slider mx-15" v-if="hideQuotes()">
    <CollapseItem
    :title="$t('INDENT_PREVIOUSLY_ACCEPTED_QUOTES')">
      <div class="tablepanel" v-if="!error">
        <div class="new" v-if="rfqData.accept_log && rfqData.accept_log.source">
          <div class="table" v-if="rfqData && rfqData.accept_log && rfqData.accept_log.source">
            <div class="table-header table-headborder">
              <div class="table-row" >
                <div class="table-th w120">{{$t('ACCEPTED ON')}}</div>
                <div class="table-th w200" v-if="hideQuotes()">{{$t('ROUTE')}}</div>
                <div class="table-th w150" v-if="hideQuotes()">{{$t('TRANSPORTER')}}</div>
                <div class="table-th w100" v-if="hideQuotes()">{{$t('VEHICLE TYPE')}}</div>
                <div class="table-th w150" v-if="hideQuotes()">{{$t('ACCEPTED QUOTE')}}  ({{currentClient.currency}}) </div>
              </div>
            </div>
          </div>
          <div class="table-row table-rowbg table-body" v-for="(quoteLog, index) in rfqData.accept_log.history" :key="index">
            <div class="table-td w120">
              <span class="table-body-td">
                    {{$moment(quoteLog.date_processed).format('DD MMM YYYY')}}
              </span>
            </div>
            <div class="table-td w200">
              <span class="table-body-td">
                {{rfqData.accept_log.source}} - <span class="ellipsis">{{rfqData.accept_log.destination.toString()}}</span>
              </span>
            </div>
            <div class="table-td w150">
              <span class="table-body-td">
                  <Ellipsis :text="quoteLog.transporter_id && quoteLog.transporter_id.vname ? quoteLog.transporter_id.vname : '-'" :length="12" />
              </span>
            </div>
            <div class="table-td w100">
              <span class="table-body-td ellipsis">
                  <Ellipsis :text="quoteLog.vehicle_id ? quoteLog.vehicle_id.short_form : '-'" :length="12" />
              </span>
            </div>
            <div class="table-td w150">
              <span class="table-body-td">
                <strong>
                    {{quoteLog.freight.rate}}/<span v-if="rfqData.quotes.length">{{ getFreightUnit(quoteLog.freight.unit).name }}</span>
                </strong>
              </span>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="ml-30">{{$t('INDENT_NO_DATA_FOUND')}}</p>
        </div>
      </div>
       </CollapseItem>
    </Collapse>
  <Collapse  accordion class="collapse-slider mx-15" v-if="hideQuotes() && rfqData.quotes">
    <CollapseItem
    :title="$t('INDENT_CURRENT_ACTIVE_CONTRACTS')" v-if="hideQuotes()">
      <div class="tablepanel popscroll">
        <div class="new"   v-if="activeContracts.length>0">
          <div class="table" v-if="activeContracts.length>0" >
            <div class="table-header table-headborder" v-if="activeContracts.length>0">
              <div class="table-row" >
                <div class="table-th w150" v-if="hideQuotes()" v-for="(header,index) in getActiveContractHeaders"
                          :key="index" >{{header.title}}</div>
                <div class="table-th w150" v-if="hideQuotes() && order.vehicle_type.type === 'PTL' ">{{$t('INDENT_MIN_CHARGE')}} ({{currentClient.currency}})</div>
                <div class="table-th w150" v-if="hideQuotes() && order.vehicle_type.type === 'FTL' ">{{$t('INDENT_POINT_CHARGE')}} ({{currentClient.currency}})</div>
              </div>
            </div>
          </div>
          <div class="table-row table-rowbg table-body" v-for="contract in activeContracts" :key="index">
            <div class="table-td w150">
              <span class="table-body-td">
                <Ellipsis :text="contract[0].name.split('-')[1]" :length="12" />
              </span>
            </div>
            <div class="table-td w200">
              <span class="table-body-td">
              <Ellipsis :text="contract[0].name.split('-')[0]" :length="12" />
              </span>
            </div>
            <div class="table-td w150">
              <span class="table-body-td ellipsis">
                  <Ellipsis :text="contract[0].vehicle_name" :length="12" />
              </span>
            </div>
             <div class="table-td w150">
              <span class="table-body-td ellipsis">
                  {{contract[0].rate}}/<span v-if="contract">{{ getFreightUnit(contract[0].unit).name }}</span>
              </span>
            </div>
            <div class="table-td w150" v-if="order.vehicle_type.type === 'PTL' ">
              <span class="table-body-td">
                <strong>
                    {{contract[0].minimum_rate}}/<span v-if="contract">{{ getFreightUnit(contract[0].unit).name }}</span>
                </strong>
              </span>
            </div>
            <div class="table-td w150"  v-if="order.vehicle_type.type === 'FTL' ">
              <span class="table-body-td">
              {{contract[0].point_charges}}/<span v-if="contract">{{ getFreightUnit(contract[0].unit).name }}</span>
              </span>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="ml-30">{{$t('INDENT_NO_DATA_FOUND')}}</p>
        </div>
      </div>
       </CollapseItem>
    </Collapse>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { contractTypes, activecontractsHeaders } from '@/constants/order';
import { RFQConstants, sourceAndDestinationType } from 'pando-constants';


export default {
  props: ['order'],
  data() {
    return {
      rfqComment: '',
      selected: null,
      rfqData: {},
      activeContracts: [],
      error: false,
      isLeastTransporter: false,
      contractTypes,
      history: true,
      activecontractsHeaders,
      RFQConstants,
      isReject: false,
    };
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
      currentClient: 'app/currentClient',
    }),
    isApprovalPending() {
      return (
        this.rfqData.quotes &&
        this.rfqData.quotes.length > 0 &&
        this.rfqData.quotes.find(_quote => _quote.status === RFQConstants.QuoteStatus.SHIPPER_SELECT)
      );
    },
    disableSelect() {
      const selectedTransporter = this.selected;
      if (selectedTransporter === null) return true ;
      const leastTransporter =
        this.rfqData && this.rfqData.quotes.length
          ? this.rfqData.quotes[0]
          : {};
      const isLeastTransporter =
        leastTransporter &&
        leastTransporter.transporter.id == selectedTransporter;
      const isRemarkMandate =
        (this.configurations.indentConfig &&
          this.configurations.indentConfig
            .rfq_remarks_mandate_not_least_trans) ||
        false;
      return isRemarkMandate && !isLeastTransporter && !this.rfqComment.length;
    },
    selectedVehicleTypeId() {
      if (this.selected) {
        const selectedQuote = this.rfqData.quotes.find(quote => quote.transporter.id === this.selected);
        return selectedQuote.vehicle_type.id;
      }
      return null;
    },
    getHistoricalPrice() {
      return this.rfqData && this.rfqData.historical_price;
    },
    getActiveContractHeaders() {
      return [
        ...this.activecontractsHeaders,
      ];
    },

  },
  async created() {
    this.loadActiveContract();
    this.load();
  },

  mounted() {},

  methods: {
    getCeilingPrice() {
      return this.rfqData && this.rfqData.ceiling_price;
    },
    disableQuote(quoteStatus) {
      const { QuoteStatus } = RFQConstants;
      if (this.isApprovalPending || this.$hasPermission('hide_rfq_quotes_price')) {
        return quoteStatus !== QuoteStatus.SHIPPER_SELECT;
      }
      return [QuoteStatus.QUOTE_SENT, QuoteStatus.SHIPPER_ACCEPT,
        QuoteStatus.SHIPPER_REJECT, QuoteStatus.TRANSPORTER_REJECT].includes(quoteStatus);
    },
    showCeilingPrice() {
      return this.$hasPermission('view_rfq_ceiling_price') && this.rfqData &&
      (this.rfqData.ceiling_price || this.rfqData.ceiling_price === 0);
    },
    getClass(quote) {
      if (quote.diff_percent != null) {
        return 'table-td w50';
      }
      return 'table-td w150';
    },
    getFreightUnit(unitId) {
      return this.contractTypes.find(contract => contract.id === unitId);
    },

    hideQuotes() {
      return !this.$hasPermission('hide_rfq_quotes');
    },
    showFreightCharges() {
      return !this.$hasPermission('hide_rfq_quotes_price');
    },
    hidebuttons() {
      return [0, 2, 3, 25, 20, 21, 22, 16].includes(this.order.status);
    },
    showHistoricalPrice() {
      return this.$hasPermission('view_rfq_historical_price') && this.rfqData &&
      (this.rfqData.historical_price || this.rfqData.historical_price === 0);
    },
    showAction() {
      return (
        this.rfqData.quotes &&
        this.rfqData.quotes.length > 0 &&
        this.rfqData.quotes.some(_quote => _quote.status === 3)
      );
    },
    showButtons() {
      return (
        this.rfqData.quotes &&
        this.rfqData.quotes.length > 0 &&
        this.rfqData.quotes.some(_quote => _quote.status === 2)
      );
    },
    hideRadiobutton() {
      this.history = false;
    },
    async statusUpdate(quoteStatus) {
      const userRejectedQuote = (quoteStatus === RFQConstants.QuoteStatus.TRANSPORTER_ACCEPT);
      const sendForApproval = (quoteStatus === RFQConstants.QuoteStatus.SHIPPER_SELECT);
      if (this.selected) {
        try {
          const payload = {
            orderNo: this.order.order_number,
            payload: {
              comment: this.rfqComment,
              userRejectedQuote,
              sendForApproval,
              quotes: [
                {
                  transporter_id: this.selected,
                  status: quoteStatus,
                  vehicle_type_id: this.selectedVehicleTypeId,
                },
              ],
            },
          };
          if (userRejectedQuote) {
            this.$emit('rejectQuote', payload);
          } else {
            const result = await this.$store.dispatch('order/rfqupdate', payload);
            if (result && result.errors) {
              this.$errorMessage({ message: result.errors });
            } else {
              const successMessage = result.successMessage || this.$t('INDENT_TRANSPORTER_ASSIGNMENT');
              this.$success({ message: successMessage });
            }
            this.$emit('closeDrawer');
          }
        } catch (e) {
          this.$error({ message: this.$t('SOMETHING_WENT_WRONG') });
        }
      } else {
        this.$error({ message: this.$t('INDENT_SELECT_TRANSPORTER_TO_INDENT') });
      }
    },
    async approveQuote() {
      if (this.selected) {
        try {
          const result = await this.$store.dispatch('order/rfqupdate', {
            orderNo: this.order.order_number,
            payload: {
              isShipperApproval: true,
              comment: this.rfqComment,
              quotes: [
                {
                  transporter_id: this.selected,
                  status: RFQConstants.QuoteStatus.SHIPPER_ACCEPT,
                  vehicle_type_id: this.selectedVehicleTypeId,
                },
              ],
            },
          });
          if (result && result.errors) {
            this.$errorMessage({ message: result.errors });
          } else {
            const successMessage = result.successMessage || this.$t('INDENT_TRANSPORTER_ASSIGNED_SUCCESS_MSG');
            this.$success({ message: successMessage });
          }
        } catch (e) {
          this.$error({ message: this.$t('SOMETHING_WENT_WRONG') });
        }
        this.$emit('closeDrawer');
      } else {
        this.$error({ message: this.$t('INDENT_SELECT_TRANSPORTER_TO_INDENT') });
      }
    },
    getTooltipContent(quoteStatus, rfqStatus) {
      if (this.isApprovalPending) {
        return '';
      }
      switch (quoteStatus) {
        case 1: {
          if (rfqStatus === 4) {
            return this.$t('INDENT_BID_EXPIRED');
          }
          return this.$t('INDENT_TRANSPORTER_YET_TO_RESPOND');
        }
        case 2: {
          return this.$t('INDENT_ALREADY_ACCEPTED');
        }
        case 4: {
          return this.$t('INDENT_SHIPPER_REJECTED');
        }
        case 5: {
          return this.$t('INDENT_TRANSPORTER_REJECTED');
        }
        default: {
          return '';
        }
      }
    },
    async load() {
      try {
        this.error = false;
        const result = await this.$store.dispatch('order/getrfqtransporters', {
          orderNo: this.order.order_number,
        });
        if (result.error) {
          this.error = true;
        } else {
          this.rfqData = result;
        }
        if ((this.order.status !== 25) && this.order.order_type === 1 && this.rfqData.status !== 1) {
          this.history = false;
        }
        if (this.rfqData && this.rfqData.quotes && this.rfqData.quotes.length) {
          const selectedQuote = this.rfqData.quotes.find(quote =>
            quote.status === RFQConstants.QuoteStatus.SHIPPER_SELECT);
          this.selected = selectedQuote ? selectedQuote.transporter.id : null;
        }
      } catch (e) {
        this.$error({ message: this.$t('SOMETHING_WENT_WRONG') });
      }
    },
    async rejectAll() {
      const params = this.rfqData.quotes.map(item => ({
        transporter_id: item.transporter.id,
        status: RFQConstants.QuoteStatus.SHIPPER_REJECT,
      }));
      if (params.length) {
        try {
          await this.$store.dispatch('order/rfqupdate', {
            orderNo: this.order.order_number,
            payload: {
              comment: this.rfqComment,
              shipperRejected: true,
              quotes: params,
            },
          });
          this.$success({ message: this.$t('INDENT_UPDATED_SUCCESS_MSG') });
          this.history = false;
          this.$emit('closeDrawer');
        } catch (e) {
          this.$error({ message: this.$t('SOMETHING_WENT_WRONG') });
        }
      }
      this.$emit('closeDrawer');
    },
    constructContractPayload() {
      const payload = {
        sources: [],
        destinations: [],
      };
      this.order.sources.forEach((sourceDetail) => {
        const source = {
          type: sourceDetail.type,
          location_id: sourceDetail.location_id,
        };
        if (source.type !== sourceAndDestinationType.CONSIGNEE) {
          source.gate_id = sourceDetail.gate_id;
        }
        payload.sources.push(source);
      });
      this.order.destinations.forEach((destinationDetail) => {
        const destination = {
          type: destinationDetail.type,
          location_id: destinationDetail.location_id,
          source_gate_id: destinationDetail.source_gate_id,
          source_location_id: destinationDetail.source_location_id,
        };
        if (destination.type !== sourceAndDestinationType.CONSIGNEE) {
          destination.gate_id = destinationDetail.gate_id;
        }
        payload.destinations.push(destination);
      });
      return payload;
    },
    async loadActiveContract() {
      try {
        const payload = this.constructContractPayload();
        if (payload.sources.length !== 0 && payload.destinations.length !== 0) {
          const result = await this.$store.dispatch(
            'indentV2/getContract',
            payload,
          );
          if (!result || result.error) {
            this.$errorMessage({
              message: this.$t('INDENT_CONTRACT_LOADING_ERROR_MSG'),
            });
          } else if (result && result.length) {
            result.forEach((contract) => {
              if (contract.transporters[0].vehicle_type === this.order.vehicle_type.type) {
                this.activeContracts.push(contract.transporters);
              }
            });
          }
        }
      } catch (err) {
        this.$errorMessage({
          message: this.$t('INDENT_CONTRACT_LOADING_ERROR_MSG'),
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$fontBold: "OpenSans-Bold";
.inprogress {
  margin: 0px;
  padding: 0 15px 10px;
  font-size: 14px;
  font-weight: normal;
  color: #646464;
}
.table{
  margin-top: 10px;
}
.table-body-td{
font-size: 1.2rem;
font-weight: normal;
text-transform:capitalize;
text-overflow: ellipsis;
}

.table-row {
  border: none;
}
.table-th {
  padding: 6px 4px !important;
  margin-left: -3px;
  align-content: center;
  align-items: center;
}
.table-bgcolor {
  display: block;
}
.trimmed {
  display: inline-block;
  width: 190px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1.2rem;
}
.text-right {
  text-align: right;
}
.ml-5 {
  margin-left: 5px;
}

.buttons-top {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  .buttons-grp{
    margin-left: auto;
    order: 2;
  }
}
.reason-footer {
  display: flex;
  padding: 10px 10px 0 10px;
  float: left;
  width: 100%;
  .reason-input {
    width: 58%;
    padding: 6px 5px 15px;

    .reason-text {
      display: block;
      color: #234357;
      font-size: 1rem;
      text-transform: uppercase;
      padding-bottom: 5px;
      padding-left: 0;
    }
    input {
      width: 100%;
      padding: 5px 0;
      font-size: 1.2rem;
      border: none;
      outline: none;
      border-radius: 0;
    }
    .popup-empty {
      width: 100%;
      padding: 15px 10px 0;
      text-align: right;
    }
  }
}
</style>
